import React from 'react';
import CalcomScheduledBadge from '../CalcomScheduledBadge/CalcomScheduledBadge';
import CalcomCancelledBadge from '../CalcomCancelledBadge/CalcomCancelledBadge';
import CalcomBookingViewButton from '../CalcomBookingViewButton/CalcomBookingViewButton';
import './calcom-booking-status.scss';

interface CalcomBookingStatusProps {
  calcomBookingUid: string | null | undefined;
  status?: string | null;
}

const CalcomBookingStatus = ({
  calcomBookingUid,
  status,
}: CalcomBookingStatusProps) => {
  const isCancelled: boolean = status?.toLowerCase() === 'cancelled';

  return (
    <div className="calcom-booking-status">
      <div className="event-info-label">Status</div>
      {isCancelled ? (
        <CalcomCancelledBadge calcomBookingUid={calcomBookingUid ?? null} />
      ) : (
        <CalcomScheduledBadge calcomBookingUid={calcomBookingUid ?? null} />
      )}
      <CalcomBookingViewButton
        bookingUid={calcomBookingUid}
        isCancelled={isCancelled}
      />
    </div>
  );
};

export default CalcomBookingStatus;